var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorFullLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 40,
    viewBox: "0 0 162 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2344_70065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.594 13.1052V30.8007H51.8371V13.1052V12.4229H52.525H58.6775V9.22363H40.7344V12.4229H46.9062H47.594V13.1052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3058 27.6211H86.7945H86.1066V26.9324V22.3041V21.6153H86.7945H94.5028V18.3968H86.7945H86.1066V17.708V13.0798V12.391H86.7945H97.3058V9.16602H81.8828V30.8268H97.3058V27.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.585 21.4283L103.162 9.22363H98.7969L110.208 30.5497L121.671 9.22363H117.241L110.8 21.4283L110.189 22.5806L109.585 21.4283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.427 26.9324V22.3041V21.6153H129.115H136.823V18.3968H129.115H128.427V17.708V13.0798V12.391H129.115H139.62V9.16602H124.203V30.8268H139.62V27.6211H129.115H128.427V26.9324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.521 19.9993L153.791 19.6066L161.023 9.22363H156.266L151.708 15.7508L151.142 16.5555L150.583 15.7508L146.031 9.22363H141.28L148.474 19.6066L148.75 19.9993L148.474 20.392L141.273 30.7878L146.031 30.8007L150.576 24.2478L151.142 23.4367L151.708 24.2478L156.272 30.8007H161.023L153.791 20.392L153.521 19.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8265 22.5162C75.318 22.0334 75.9673 21.6214 76.8545 20.5979C77.9281 19.3492 78.4489 18.0682 78.4489 16.6778V16.0791C78.4489 13.8261 77.626 12.7318 76.0059 11.3994C74.2829 9.99608 71.8463 9.22363 69.1526 9.22363H60.75L60.7693 30.8007H64.9931V20.128H64.9738V12.4164H68.8055C70.387 12.4164 71.8721 12.822 72.6885 13.4785H72.7014L72.7078 13.4914C73.6014 14.2639 74.0515 15.1779 74.0515 16.2207C74.0515 18.3836 72.0906 20.1409 69.6862 20.1409H67.1339V20.128H65.6038L66.221 20.9069L74.0129 30.7943H79.111L73.4986 23.5912L72.8943 22.8187L73.8265 22.5162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0428 27.1578H18.4297V39.9933L36.8486 21.5511C30.7604 20.7915 25.2508 20.4632 20.3841 20.4053L22.0428 27.1513V27.1578Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.4551C3.67092 19.1181 9.27696 19.8455 16.5867 19.9743L16.6767 19.6138C15.5709 18.9958 14.8187 17.8114 14.8187 16.4532C14.8187 14.4577 16.4388 12.8355 18.4318 12.8355V0",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4284 40.0004V27.1648H14.8153L16.474 20.4316C9.4407 20.5604 3.99539 21.2491 0.34375 21.8929L12.1987 26.2508L18.4348 40.0068L18.4284 40.0004Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0428 16.4596C22.0428 17.8178 21.297 19.0023 20.1848 19.6202L20.2748 19.9936C25.2636 19.9421 30.9275 19.6009 37.2022 18.8027L24.6593 13.756L18.4297 0V12.842C20.4227 12.842 22.0428 14.4641 22.0428 16.4596Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2086 18.8027L18.4297 0L24.6658 13.756L37.2086 18.8027Z",
    fill: "url(#paint0_linear_2344_70065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2086 18.8027L18.4297 0L24.6658 13.756L37.2086 18.8027Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1987 26.2436L0.34375 21.8857L18.4348 39.9997L12.1987 26.2436Z",
    fill: "url(#paint1_linear_2344_70065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1987 26.2436L0.34375 21.8857L18.4348 39.9997L12.1987 26.2436Z",
    fill: "#E2833D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2344_70065",
    x1: 25.1479,
    y1: 20.5858,
    x2: 27.9319,
    y2: 8.94269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2344_70065",
    x1: 14.5131,
    y1: 21.5768,
    x2: 9.26978,
    y2: 31.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2344_70065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161.026,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorFullLogo);
export default __webpack_public_path__ + "static/media/colorFull_logo.815ef1caad24aa21393f92c59ab02a8a.svg";
export { ForwardRef as ReactComponent };